module.exports = __webpack_public_path__ + "static/media/notificationAudio.09b682ef.mp3";